module.exports = __webpack_public_path__ + "static/img/yt.f06d254d.svg";